import { MotionBlurFilter as PixiMotionBlurFilter } from 'pixi-filters'
import { EffectState } from '@/pixi/filters/types'
import AudioIntensityAnalyzer from '@/audio/AudioIntensityAnalyzer'
import { SeratoFilter } from '@/pixi/filters/types'
import useAudioEngine from '@/composables/UseAudioEngine'
const { audioBackgroundIntensity } = useAudioEngine()

export class MotionBlurFilter extends PixiMotionBlurFilter implements SeratoFilter {

  constructor (private effectState: EffectState) {
    super()
  }

  public updateUniforms () : void {
    const audioIntensity = this.effectState.audioReactivityEnabled
      ? AudioIntensityAnalyzer.getAudioIntensity(this.uniforms.audioFrequencyData, audioBackgroundIntensity.value) : 1

    const velocity = (this.effectState.intensity + 0.15) * audioIntensity * 100
    this.velocity.set(velocity, 0)
  }
}
